import { z } from "zod";

export const routingNumber = () =>
  z
    .string()
    .length(9, { message: "Routing number must be exactly 9 digits long" });
